import Button from 'components/Button';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  p {
    text-align: center;
    margin-bottom: 3rem;
  }
`;

const LoginRequired: FC = () => {
  return (
    <Container>
      <p>Vous devez être connecté pour accéder à cette page.</p>
      <Link to="/authentication/login">
        <Button color="primary" variant="filled">
          Se connecter
        </Button>
      </Link>
    </Container>
  );
};

export default LoginRequired;
